import React from 'react';
import ReactTooltip from 'react-tooltip';

const Tooltip = ({
  wrapperClass = '',
  targetClass = '',
  targetElement,
  tooltipElement,
  tooltipProps = {},
}) => {
  const defaultTooltipProps = {
    className: '',
    id: '',
    place: 'top',
    effect: 'solid',
    isCapture: true,
    type: 'light',
    border: true,
    borderColor: '#FABC73',
    textColor: '#58667e',
  };

  return (
    <div className={wrapperClass}>
      <div className={targetClass}>
        {targetElement}
      </div>
      <ReactTooltip {...defaultTooltipProps} {...tooltipProps}>
        {tooltipElement}
      </ReactTooltip>
    </div>
  );
};

export default Tooltip;
